<template>
    <div>
        <div class="modal-header">
            <h2 class="text-center">Vil du afslutte henvendelsen?</h2>
        </div>

        <p class="text-center">Er du sikker på, at du vil afslutte henvendelsen?<br />Den forsvinder fra listen, og du skal klikke på "Afsluttede" for at finde den igen.</p>
        <div class="form form-modal">
            <div class="grid-x">
                <div class="cell small-1 medium-1 large-1">
                    <icon class="small-svg" name="building" />
                </div>
                <div class="cell small-3 medium-3 large-3" :class="{'border-bottom': data.enquiry.clientResponse}">
                    <label>Vedrører ikke forsyningen</label>
                </div>
                <div class="cell auto" :class="{'border-bottom': data.enquiry.clientResponse}">
                    <input type="checkbox" v-model="concernDepartment">
                </div>
            </div>
        </div>
        <div class="form form-modal modal-subheader" v-if="data.enquiry.clientResponse">
            <div class="grid-x">
                <div class="cell small-1 medium-1 large-1"></div>
                <h3 v-if="data.enquiry.clientPhone && !data.enquiry.clientEmail">Tilbagemelding skal foretages på tlf.: {{data.enquiry.clientPhone}}</h3>
                <h3 v-else-if="data.enquiry.clientEmail">Tilbagemelding bliver sendt ud på e-mail: {{data.enquiry.clientEmail}}</h3>
                <h3 v-else>Tilbagemelding ønskes (ingen kontaktoplysninger angivet)</h3>
            </div>
        </div>

        <div class="modal-footer">
            <div class="text-center modal-buttons">
                <button type="button" class="button-green" @click="closeEnquiry()">Ja</button>
                <button type="button" class="button-red" @click="closeModal()">Nej</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'enquiry-modal-close',
    data () {
        return {
            concernDepartment: false,
            statusTypeId: '',
            useStandardMsg: true,
            feedbackMail: '',
            userFeedbackMail: ''
        }
    },
    props: {
        data: Object
    },
    watch: {
        useStandardMsg () {
            if (this.useStandardMsg) {
                this.userFeedbackMail = this.feedbackMail
                this.selectedEnquiry.useStandardMail = true
                this.feedbackMail = this.concernDepartment ? this.selectedEnquiry.templateMailStandardNoConcern : this.selectedEnquiry.templateMailStandard
            } else {
                if (this.userFeedbackMail) {
                    this.feedbackMail = this.userFeedbackMail
                } else {
                    this.feedbackMail = this.concernDepartment ? this.selectedEnquiry.templateMailStandardNoConcern : this.selectedEnquiry.templateMailStandard
                }
                this.selectedEnquiry.useStandardMail = false
                this.selectedEnquiry.feedbackMail = this.feedbackMail
            }
        },
        concernDepartment () {
            if (this.useStandardMsg) {
                this.feedbackMail = this.concernDepartment ? this.selectedEnquiry.templateMailStandardNoConcern : this.selectedEnquiry.templateMailStandard
            }
        }
    },
    computed: {
        ...mapGetters({
            selectedEnquiry: 'getSelectedEnquiry',
            statusTypeList: 'getSysRequestStatusTypeList'
        })
    },
    methods: {
        ...mapActions({
            setEnquiryStatus: 'setEnquiryStatus'
        }),
        closeEnquiry () {
            this.statusTypeId = ''
            for (let i in this.statusTypeList) {
                if (this.concernDepartment) {
                    if (this.statusTypeList[i].code === 6) {
                        this.statusTypeId = this.statusTypeList[i].sysRequestStatusTypeId
                    }
                } else {
                    if (this.statusTypeList[i].code === 5) {
                        this.statusTypeId = this.statusTypeList[i].sysRequestStatusTypeId
                    }
                }
            }
            this.changeEnquiryStatus(this.statusTypeId, true)
        },
        changeEnquiryStatus (statusId, closed) {
            let enquiryData = {
                'requestId': this.selectedEnquiry.requestId,
                'requestStatusTypeId': statusId,
                'closed': closed
            }
            this.setEnquiryStatus(enquiryData).then(() => {
                this.$emit('close')
                this.$nextTick(() => {
                    this.$router.push({
                        name: 'dashboard'
                    })
                })
            })
        },
        closeModal () {
            this.$emit('close')
        }
    },
    created () {
        if (this.useStandardMsg) {
            this.feedbackMail = this.selectedEnquiry.templateMailStandard
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/enquiry/enquiry-modal-close.vue